import styles from './CardDraftLabel.module.scss';
import { CardDraftLabelProps } from './CardDraftLabel.types';

export function CardDraftLabel({ text = 'DRAFT' }: CardDraftLabelProps) {
  return <div className={styles.wrapper}>{text}</div>;
}
